<template>
<div>
    <div class="pdyx">
        <img src="../assets/images/flat/pc/my-xy.png" alt="">
    </div>
</div>
</template>
<script>

export default {
    components: {},
    data() {
        return {
            msg: ''
        }
    },
    mounted() {

    },
    methods(){}
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// Pdxy.vue?7659e0ce